import { Hub, Session } from '@bimone/bimtrack-core';
import { useSession } from '../../app/modules/session';

export function useBimTrackApi(hub?: Hub): string {
  const session = useSession();
  return getBimTrackApiUrl(session, hub);
}

export const getBimTrackApiUrl = (session: Session, hub?: Hub): string => {
  if (hub?.bimTrackRegionalApiUrl) {
    return hub.bimTrackRegionalApiUrl;
  }

  return session.bimTrackApiUrl;
};
